import React from "react";

export default function SectionCard({ title, description, items, children }) {
  return (
    <div className="card-uniform">
      
      <h4 className="mb-3">{title}</h4>

      {description && (
        <p className="text-muted">{description}</p>
      )}

      {items && (
        <ul className="list-unstyled mb-3">
          {items.map((item, index) => (
            <li key={index} className="mb-2">
              <i className={item.icon + " me-2"} style={{ color: "#002AAD" }}></i>
              {item.text}
            </li>
          ))}
        </ul>
      )}

      {children}
    </div>
  );
}

